import { withNestedView } from '@/router/routerHelpers';
import { FEATURES } from '@/access/features';

const loadView = withNestedView('agents');

const agentsRoutes = [
  {
    path: '/agents',
    component: { render: (c) => c('router-view') },
    children: [
      {
        path: '',
        name: 'agents',
        component: loadView('Agents'),
        meta: { showNav: true, feature: FEATURES.CUSTOM_AGENTS },
      },
      {
        path: 'new',
        name: 'agentsNew',
        component: loadView('AgentDetail'),
        props: { isNew: true },
        meta: { showNav: true, feature: FEATURES.CUSTOM_AGENTS },
      },
      {
        path: ':id',
        component: loadView('AgentDetail'),
        props: true,
        meta: { showNav: true, feature: FEATURES.CUSTOM_AGENTS },
        children: [
          { path: '', redirect: 'identity' },
          {
            path: 'identity',
            name: 'agentIdentity',
            component: loadView('tabs/AgentIdentityTab'),
          },
          {
            path: 'instructions',
            name: 'agentInstructions',
            component: loadView('tabs/AgentInstructionsTab'),
          },
          {
            path: 'tools',
            name: 'agentTools',
            component: loadView('tabs/AgentToolsTab'),
          },
          {
            path: 'instances',
            name: 'agentInstances',
            component: loadView('tabs/AgentInstancesTab'),
          },
          {
            path: 'contacts',
            name: 'agentContacts',
            component: loadView('tabs/AgentContactsTab'),
          },
          {
            path: 'test',
            name: 'agentTest',
            component: loadView('tabs/AgentTestTab'),
          },
          {
            path: 'logs',
            name: 'agentLogs',
            component: loadView('tabs/AgentLogsTab'),
          },
        ],
      },
    ],
  },
];

export default agentsRoutes;
